module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_dac_m_en.2611536e3c4fd73c7176229539485f5a.png";